import moment from 'moment';

export const initialConsent = {
    titleTh: '',
    titleEn: '',
    templateNameTh: '',
    templateNameEn: '',
    logoId: '',
    firstParagraphTh: '',
    firstParagraphEn: '',
    consentForms: [],
    consents: [],
    certificationTh: '',
    certificationEn: '',
    contactChannelTh: '',
    contactChannelEn: '',
    effectiveDate: moment(),
    progress: 0,
    templateDesignIdentity: [
        {
            labelNameTh: '',
            labelNameEn: '',
        },
    ],
};
